import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CustomImage = ({ imageUrl, fontSize }) => {
  const [imageType, setImageType] = useState(null);
  const [svgData, setSvgData] = useState(null);

  const imageCache = {};  // cache images to avoid fetching them multiple times

  useEffect(() => {
    if (imageUrl.endsWith('.svg')) {
      setImageType('svg');
      if (!imageCache[imageUrl]) {
        imageCache[imageUrl] = axios.get(imageUrl)
          .then(response => response.data)
          .catch(error => {
            console.error('Error fetching SVG data:', error);
          });
      }
      imageCache[imageUrl].then(setSvgData);
    } else if (imageUrl.endsWith('.png') || imageUrl.endsWith('.jpg')) {
      setImageType('raster');
      if (!imageCache[imageUrl]) {
        // preload the image so there's no delay on first render
        const img = new Image();
        img.src = imageUrl;
        imageCache[imageUrl] = new Promise((resolve, reject) => {
          img.onload = () => resolve(img);
          img.onerror = reject;
        });
      }
    }
  }, [imageUrl]);

  if (imageType === 'svg') {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: svgData }}
        style={{ width: '100%', height: '100%' }}
      />
    );
  } else if (imageType === 'raster') {
    return (
      <img src={imageUrl} alt="Response icon" style={{ width: '100%', height: '100%' }} />
    );
  } else {
    return null;
  }
};

export default CustomImage;
